import script from "./DashboardSearchUser.vue?vue&type=script&setup=true&lang=js"
export * from "./DashboardSearchUser.vue?vue&type=script&setup=true&lang=js"

import "./DashboardSearchUser.vue?vue&type=style&index=0&id=04d58faa&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-04d58faa"]])

export default __exports__